const l = ['driver', 'phone', 'car']

export const getLable = (item, labels, type) => {
  let arr = ['driver']
  if (typeof labels === 'string') {
    arr = labels.split(',')
  }
  if (Array.isArray(labels)) {
    arr = labels
  }
  const obj = {
    ...item,
    driver: item.driverName,
    phone: item.driverPhone,
    car: item.plateNumber
  }
  let label = ''
  if (type === 'driver' || type === 'all') {
    arr = arr.sort((a, b) => {
      if (a === 'driver') {
        return -1
      }
      return 1
    })
  } else {
    arr = arr.sort((a, b) => {
      if (a === 'car') {
        return -1
      }
      return 1
    })
  }
  arr.forEach((el) => {
    let val = obj[el]
    if (arr.length > 1) {
      val += ' '
    }
    if (obj[el]) {
      label += val
    }
  })
  return label || obj.driver
}

export const validatorlabels = (val) => {
  if (typeof val === 'string') {
    return l.includes(val)
  }
  if (Array.isArray(val)) {
    return true
  }
  return false
}

// 是否可选已封禁状态
export const getDisabled = (item, isCheckDisabled) => {
  if (isCheckDisabled) {
    return false
  }
  const status = item.status
  const arr = [3, 4]
  return arr.includes(status)
}

// 可选已封禁时，展示已封禁标签
export const getShowSpan = (item, isCheckDisabled) => {
  if (!isCheckDisabled) {
    return false
  }
  const status = item.status
  const arr = [3, 4]
  return arr.includes(status)
}

// 如果为绑定关系的车辆司机，则已车辆id为值
export const getValue = (item, type) => {
  if (type === 'driver') {
    return item.driverId + ''
  }
  return item.carId + ''
}
